var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7794 15.2825H13.5581V11.8018C13.5581 10.9718 13.5413 9.90375 12.4006 9.90375C11.2425 9.90375 11.0656 10.8069 11.0656 11.7406V15.2825H8.84435V8.125H10.9781V9.10058H11.0068C11.305 8.53808 12.03 7.94437 13.1131 7.94437C15.3638 7.94437 15.78 9.42567 15.78 11.3538L15.7794 15.2825ZM6.33562 7.14562C5.62062 7.14562 5.04625 6.56687 5.04625 5.855C5.04625 5.14375 5.62125 4.56563 6.33562 4.56563C7.04812 4.56563 7.62563 5.14375 7.62563 5.855C7.62563 6.56687 7.0475 7.14562 6.33562 7.14562ZM7.44938 15.2825H5.22188V8.125H7.44938V15.2825ZM16.8906 2.5H4.10687C3.495 2.5 3 2.98375 3 3.58063V16.4194C3 17.0168 3.495 17.5 4.10687 17.5H16.8888C17.5 17.5 18 17.0168 18 16.4194V3.58063C18 2.98375 17.5 2.5 16.8888 2.5H16.8906Z",
    fill: "#0A66C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlue);
export default __webpack_public_path__ + "static/media/Linkedin-blue.06a34391d0aadbd72ba37f9a16bff2c9.svg";
export { ForwardRef as ReactComponent };